import Link from 'next/link'
import CustomButton from '@/components/ui/button'
import { memo, useCallback, useState } from 'react'
import styles from './styles.module.css'
import ButtonTabs from '@/components/ui/button-tabs'
import { useRouter } from 'next/router'

const InfoCardWithTwoButtons = ({ card: { label, count, buttons } }) => {
  const router = useRouter()
  const [active, setActive] = useState(buttons[0].value)
  const isCurrent = useCallback(
    (current) => {
      return active === current.value
    },
    [buttons]
  )
  const changeTab = useCallback(
    (item) => {
      router.push(item?.link)
      setActive(item.value)
    },
    [setActive]
  )
  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardText}>
        <div className={styles.cardCount}>{count}</div>
        <div className={styles.cardLabel}>{label}</div>
      </div>
      <div className={styles.cardButtons}>
        <ButtonTabs buttons={buttons} onClick={changeTab} isCurrent={isCurrent} />
      </div>
    </div>
  )
}

export default memo(InfoCardWithTwoButtons)
